import { render } from "./AnnouncementModal.vue?vue&type=template&id=03899e41"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__